/**
 * To-do items API calls.
 */

import client from './client';

export async function fetchTodos(params = {}) {
  const { data } = await client.get('/todos/', { params });
  return data;
}

export async function createTodo(payload) {
  const { data } = await client.post('/todos/', payload);
  return data.data;
}

export async function updateTodo(id, payload) {
  const { data } = await client.patch(`/todos/${id}/`, payload);
  return data.data;
}

export async function deleteTodo(id) {
  await client.delete(`/todos/${id}/`);
}

export async function toggleTodo(id) {
  const { data } = await client.post(`/todos/${id}/toggle/`);
  return data.data;
}

export async function fetchTodoMyCount() {
  const { data } = await client.get('/todos/my-count/');
  return data.data;
}

export async function fetchTodoJobCounts() {
  const { data } = await client.get('/todos/job-counts/');
  return data.data;
}
